/**
 * Wspólny kontrakt rozpoznawania intencji dotyku w świecie gry.
 *
 * Joystick i interakcje Phasera widzą ten sam gest rozpoczęty na canvasie.
 * Martwa strefa jest równa progowi anulowania holda: kierunkowy ruch kciuka
 * przejmuje joystick dokładnie wtedy, gdy interakcja się kończy, a nieruchomy
 * palec nie przesuwa postaci podczas wypełniania pierścienia.
 */
export const WORLD_INTERACTION_INPUT = {
  standardHoldMs: 450,
  movingPlayerHoldMs: 250,
  cancelDistancePx: 16,
  joystickDeadZonePx: 16,
  indicatorOffsetY: 52,
} as const;
